import privacy from "./legal/privacy.md?raw";
import terms from "./legal/terms.md?raw";
import refunds from "./legal/refunds.md?raw";
import cookies from "./legal/cookies.md?raw";
import accessibility from "./legal/accessibility.md?raw";
import aiPolicy from "./legal/ai-policy.md?raw";

// The privacy policy, terms of use, refund policy, cookies list, accessibility statement and AI policy. The documents themselves are Markdown
// files in ./legal, for a lawyer to review and edit (see src/i18n/README.md); these are the words around them.
export const legalPages = {
    effective: 'Effective {date}',
    lastReviewed: 'Last reviewed {date}',
    privacy: {
        title: 'Privacy policy',
        description: "What personal data Tristar Advanced Software collects, why, how long it's kept, and your rights.",
        document: privacy
    },
    terms: {
        title: 'Terms of use',
        description: 'The terms for using the Tristar Advanced Software website and accounts.',
        document: terms
    },
    refunds: {
        title: 'Refund policy',
        description: 'When you can get a refund for a Tristar Advanced Software license, and how to ask for one.',
        document: refunds
    },
    cookies: {
        title: 'Cookies and browser storage',
        description: 'The cookies and browser storage this website uses, and what each is for.',
        document: cookies
    },
    accessibility: {
        title: 'Accessibility statement',
        description: 'How accessible this website is, and how to tell us about a problem.',
        document: accessibility
    },
    aiPolicy: {
        title: 'AI policy',
        description: 'How Tristar Advanced Software uses AI, and what we will never use it for.',
        document: aiPolicy
    }
};

export type LegalPagesMessages = typeof legalPages;
